import React from 'react';
import './index.scss';
import Answer from '../../components/answer/index.js';
import ACTImage from '../../images/taking-asthma-control-test.svg';
import QuestionImage from '../../images/group-of-question-marks.svg';

const Intro = (props)=> {
  return(
		<section>
			<div className="content-container">
				<div className="col-xs-12">
					<div className="borderOuterContainer">
						<div className="borderInnerContainer">
							<div className="screen intro">
								<img className="actImage" src={ACTImage} alt="Taking Asthma Control Test" />
								<form onSubmit={props.formHandler} className="actView fadeIn">
									<div className="question">
										<img className="questionImage" src={QuestionImage} alt="" />
										<h5><span className="header5">Get Started</span></h5>
										<p className="base-copy">This questionnaire will ask a series of questions about your asthma symptoms over the last 4 weeks.</p>
										<p><span className="quote">Who are you taking this test for?</span></p>
										<Answer handler={props.answerHandler} id="me" set="who" value="adult" updateState={props.stateHandler}>Someone 12 years or older</Answer>
										<Answer handler={props.answerHandler} id="child" set="who" value="child" updateState={props.stateHandler}>Someone under 12 years old</Answer>
										<button className="next start" type="submit" onClick={props.nextHandler} disabled>Next</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
  );
}

export default Intro;
